import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FormStorageService {

  constructor() {}

  save<T>( key: string, data: T): void {
    try{
      localStorage.setItem(key, JSON.stringify(data));
      console.log(`Saved to localStorage under key ${key}`);
    } catch(e) {
      console.error(`Error saving form data to localStorage under key ${key}`, e);
    }
  }

  load<T>(key: string): T | null{
    try{
      const data = localStorage.getItem(key);
      if (data){
        return JSON.parse(data) as T;
      }
    } catch(e){
      console.error(`Error loading form data from localStorage under key ${key}`, e);
    }
    return null;
  }

  clear(key: string): void {
    try {
      localStorage.removeItem(key);
      console.log(`Form data cleared from localStorage under key ${key}`);

    } catch(e) {
      console.error(`Error clearing form data from localStorage under key ${key}`, e);
    }
  }
}
